import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {back} from '../../icons';
import {observer} from 'mobx-react';

interface AdvanceScanResultHeaderProps {
    onClickBack: () => void;
    textButton: string;
    textHeader: string;
}

@observer
export class AdvanceScanResultHeader extends TechseeBaseComponent<AdvanceScanResultHeaderProps> {
    renderInternal() {
        const {textButton, textHeader, onClickBack} = this.props;

        return (
            <div className={'advance-wifi-analyzer-scan-header'}>
                <div className={'advance-wifi-analyzer-scan-header-button-container'} onClick={onClickBack}>
                    {back}
                    <span className={'advance-wifi-analyzer-scan-header-button'}>{textButton}</span>
                </div>
                <div className={'advance-wifi-analyzer-scan-header-title'}>
                    <span>{textHeader}</span>
                </div>
            </div>
        );
    }
}
